import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NotificationDialogComponent } from "../../components/notification-dialog/notification-dialog.component";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
export const DialogPopupButtons = {
    cancelDelete: [
        {
            label: "@@actions.cancel",
            value: false
        },
        {
            label: "@@actions.delete",
            value: true,
            color: "warn"
        }
    ],
    yesNo: [
        {
            label: "@@actions.no",
            value: false
        },
        {
            label: "@@actions.yes",
            value: true,
            color: "primary"
        }
    ]
};
export class MaterialDialogNotifier {
    constructor(matDialog) {
        this.matDialog = matDialog;
    }
    info(title, message, onClose) {
        this.openDialog(title, message, onClose, "info");
    }
    success(title, message, onClose) {
        this.openDialog(title, message, onClose, "info");
    }
    debug(title, message, onClose) {
        this.openDialog(title, message, onClose, "info");
    }
    warn(title, message, onClose) {
        this.openDialog(title, message, onClose, "info");
    }
    error(title, message, onClose) {
        this.openDialog(title, message, onClose, "error");
    }
    async confirmation(title, message, buttons, callback) {
        if (typeof callback === "function")
            this.openDialog(title, message, callback, "info", { buttons });
        else
            return this.openDialogPromise(title, message, "info", { buttons });
    }
    openDialog(title, message, onClose, cssClass, additionalDialogData = {}) {
        additionalDialogData.title = title;
        additionalDialogData.message = message;
        this.matDialog
            .open(NotificationDialogComponent, {
            panelClass: cssClass,
            data: additionalDialogData,
            disableClose: true
        })
            .beforeClosed()
            .subscribe(onClose);
    }
    openDialogPromise(title, message, cssClass, additionalDialogData = {}) {
        return new Promise((resolve) => {
            additionalDialogData.title = title;
            additionalDialogData.message = message;
            this.matDialog
                .open(NotificationDialogComponent, {
                panelClass: cssClass,
                data: additionalDialogData,
                disableClose: true
            })
                .beforeClosed()
                .subscribe(resolve);
        });
    }
}
MaterialDialogNotifier.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialDialogNotifier, deps: [{ token: i1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
MaterialDialogNotifier.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialDialogNotifier });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialDialogNotifier, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MatDialog }]; } });
